import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const moduleModals = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    productImages: {
      favorites: {},
      startOver: {},
      buyPanel: {}
    }
  }
};

export default moduleModals;
